import { Auth } from "aws-amplify"
import config from './../config.js';
import axios from 'axios';
import awsconfig from './../aws-exports-config';

export default {
    async GenerateS3PresignedUploadUrl(folderDestination, objectFile, fileName,brandCode) {
        const formData = new FormData();
        formData.append('file', objectFile);
        formData.append('folder', folderDestination);
        formData.append('filename', fileName);
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/presigned-urlupload", formData, { headers });
        const data = response.data;
        return data;
    },

    async DownloadFile(link) {
        document.location.href = link;
    },

    async CreateRaffleEvent(brandCode, raffleModel) {
        const idToken = (await Auth.currentSession()).getIdToken().getJwtToken();
    
        const requestBody = {
            raffleName: raffleModel.raffleName,
            sku: raffleModel.sku,
            raffleDate: raffleModel.raffleDate,
            startDate: raffleModel.startDate,
            endDate: raffleModel.endDate,
            region: raffleModel.region,
            province: raffleModel.province,
            city: raffleModel.city,
            winners: raffleModel.winners,
            prizeId: raffleModel.prizeId,
            prizeName: raffleModel.prizeName,
            eventType: raffleModel.eventType,
            promoId: raffleModel.promoId,
            deductionAmount: raffleModel.deductionAmount,
            locations: raffleModel.locations, // Assuming raffleModel.locations is already an array of location objects
            eventDetailImageUrl: raffleModel.eventDetailImageUrl
        };
    
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${idToken}`,
            'Content-Type': 'application/json' // Set content type to JSON
        };
    
        const response = await axios.post(
            config.GiveAwayAPI_URL + "/api/add-raffle-event",
            requestBody,
            {
                headers: headers
            }
        );
    
        const data = response.data;
        return data;
    },
    
    async UpdateRaffleEvent(brandCode, raffleModel) {
        const idToken = (await Auth.currentSession()).getIdToken().getJwtToken();
    
        const requestBody = {
            id: raffleModel.id,
            raffleName: raffleModel.raffleName,
            sku: raffleModel.sku,
            raffleDate: raffleModel.raffleDate,
            startDate: raffleModel.startDate,
            endDate: raffleModel.endDate,
            region: raffleModel.region,
            province: raffleModel.province,
            city: raffleModel.city,
            winners: raffleModel.winners,
            prizeId: raffleModel.prizeId,
            prizeName: raffleModel.prizeName,
            eventType: raffleModel.eventType,
            promoId: raffleModel.promoId,
            deductionAmount: raffleModel.deductionAmount,
            locations: raffleModel.locations, // Assuming raffleModel.locations is already an array of location objects
            eventDetailImageUrl: raffleModel.eventDetailImageUrl
        };
    
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${idToken}`,
            'Content-Type': 'application/json' // Set content type to JSON
        };
    
        const response = await axios.put(
            config.GiveAwayAPI_URL + "/api/update-raffle-event",
            requestBody,
            {
                headers: headers
            }
        );
    
        const data = response.data;
        return data;
    },
    
    async DeleteRaffleEvent(brandCode, raffle) {
        const formData = new FormData();
        formData.append('id', raffle.id);
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.delete(config.GiveAwayAPI_URL + "/api/delete-raffle-event", { data: formData, headers: { 'Content-Type': 'multipart/form-data', ...headers } });
        const data = response.data;
        return data;
    },

    async GetAllRaffleEvent(brandCode) {
        const idToken = (await Auth.currentSession()).getIdToken().getJwtToken()
        const response = await axios.get(
            config.GiveAwayAPI_URL + "/api/get-raffle-event",
            {
                headers: {
                    'brand-code': brandCode,
                    Authorization: `Bearer ${idToken}`
                },
                params: {
                    brandCode: brandCode,
                },
            }
        );
        const data = response.data;
        return data;
    }, 

    async GetAllRaffleEventWinner(brandCode, isApproved, filter){
        const idToken = (await Auth.currentSession()).getIdToken().getJwtToken()
        const response = await axios.get(
            config.GiveAwayAPI_URL + "/api/get-raffle-event-winners",
            {
                headers: {
                    'brand-code': brandCode,
                    Authorization: `Bearer ${idToken}`
                },
                params: {
                    isApproved: isApproved,
                    raffleEventId: filter.raffle_id,
                    raffleEventName: filter.raffle_name
                },
            }
        );
        const data = response.data;
        return data;
    }, 

    async UpdateStatusRaffleEventWinner(brandCode,id ,status) {
        const formData = new FormData();
        formData.append('id', id);
        formData.append('isApproved', status);
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/update-status-raffle-event-winner",formData, { headers });
        const data = response.data;
        return data;
    },

    async GetAllProvinceCity(brandCode, regionName, provinceName, cityName) {
        const idToken = (await Auth.currentSession()).getIdToken().getJwtToken()
        const response = await axios.get(
            config.GiveAwayAPI_URL + "/api/get-all-province-city",
            {
                headers: {
                    'brand-code': brandCode,
                    Authorization: `Bearer ${idToken}`
                },
                params: {
                    brandCode: brandCode,
                    regionName: regionName,
                    provinceName: provinceName,
                    cityName: cityName
                }
            }
        );
        const data = response.data;
        return data;
    }, 

    async GetRegionProvinceCity(brandCode, regionName, provinceName, action) {
        const idToken = (await Auth.currentSession()).getIdToken().getJwtToken()
        const response = await axios.get(
            config.GiveAwayAPI_URL + "/api/get-region-province-city",
            {
                headers: {
                    'brand-code': brandCode,
                    Authorization: `Bearer ${idToken}`
                },
                params: {
                    regionName: regionName,
                    provinceName: provinceName,
                    action : action,
                }
            }
        );
        const data = response.data;
        return data;
    },  

    async UploadProvinceCity(file, brandCode) {
        const headers = {
            Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
            'brand-code': brandCode,
        };

        let data = new FormData();
        data.append('base64File', file);
        const response = await axios.post(config.GiveAwayAPI_URL + '/api/upload-province-city-excel', data, { headers });
        return response;
    },

    async S3PutObject(presignedUrl, objectFile) {
        // await axios.put(presignedUrl, objectFile);
        await fetch(presignedUrl, { method: "PUT", body: objectFile });
    },

    async fetchAllGiveawayMerchantList(brandCode) {
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.get(config.GiveAwayAPI_URL + "/api/get-merchants", { headers });
        const data = response.data;
        return data;
    },

    async getMerchantDetail(merchant_id, brandCode) {
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.get(config.GiveAwayAPI_URL + "/api/get-merchant-detail?merchant_id=" + merchant_id, { headers });
        const data = response.data;
        return data;
    },

    async checkExistFlashPromoConfig(brandCode,start_date,end_date,flash_promoId) {
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.get(config.GiveAwayAPI_URL + "/api/check-exist-flash-promo-config?start_date=" + start_date+"&&end_date="+end_date+"&&flash_promoId=" + flash_promoId, { headers });
        const data = response.data;
        return data;
    },
    async GetAllFlashPromoConfig(brandCode) {
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.get(config.GiveAwayAPI_URL + "/api/get-all-flash-promo-config", { headers });
        const data = response.data;
        return data;
    },
    async GetTimeZoneConfig(brandCode) {
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.get(config.GiveAwayAPI_URL + "/api/get-time-zone-config", { headers });
        const data = response.data;
        return data;
    },
    
    async AddFlashPromoConfig(brandCode,flash_promo_data_add) {
        const formData = new FormData();
        formData.append('id', flash_promo_data_add.id);
        formData.append('brandCode', flash_promo_data_add.brandCode);
        formData.append('promotion_name', flash_promo_data_add.promotion_name);
        formData.append('discount_type', flash_promo_data_add.discount_type);
        formData.append('promotion_amount', flash_promo_data_add.promotion_amount);
        formData.append('is_active', flash_promo_data_add.is_active);
        formData.append('start_date', flash_promo_data_add.start_date);
        formData.append('end_date', flash_promo_data_add.end_date);
        formData.append('created_date_utc', flash_promo_data_add.create_date);
        formData.append('modified_date_utc', flash_promo_data_add.modify_date);

        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/add-flash-promo-config",formData, { headers });
        const data = response.data;
        return data;
    },

    async UpdateFlashPromoConfig(brandCode,flash_promo_data_update) {
        const formData = new FormData();
        formData.append('id', flash_promo_data_update.id);
        formData.append('brandCode', flash_promo_data_update.brandCode);
        formData.append('promotion_name', flash_promo_data_update.promotion_name);
        formData.append('discount_type', flash_promo_data_update.discount_type);
        formData.append('promotion_amount', flash_promo_data_update.promotion_amount);
        formData.append('is_active', flash_promo_data_update.is_active);
        formData.append('start_date', flash_promo_data_update.start_date);
        formData.append('end_date', flash_promo_data_update.end_date);
        formData.append('created_date_utc', flash_promo_data_update.create_date);
        formData.append('modified_date_utc', flash_promo_data_update.modify_date);
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/update-flash-promo-config",formData, { headers });
        const data = response.data;
        return data;
    },

    async DeleteFlashPromoConfig(brandCode,body) {
        const formData = new FormData();
        formData.append('id', body.id);
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.delete(config.GiveAwayAPI_URL + "/api/delete-flash-promo-config", { data: formData, headers: { ...headers } });
        const data = response.data;
        return data;
    },
    //start global promo config
    async AddGlobalPromoConfig(brandCode,promo_data) {
        const formData = new FormData();
        formData.append('brand_code', promo_data.brand_code);
        formData.append('promotion_name', promo_data.promotion_name);
        formData.append('promotion_type', promo_data.promotion_type);
        formData.append('trigger_id', promo_data.trigger_id);
        formData.append('is_giid_only', promo_data.is_giid_only ? 1 : 0);
        formData.append('max_chance_per_day', promo_data.max_chance_per_day);
        formData.append('addition_rules_id', promo_data.addition_rules_id_list);
        formData.append('start_date_promo', promo_data.start_date_promo);
        formData.append('end_date_promo', promo_data.end_date_promo);
        formData.append("promo_group", promo_data.promo_group);
        formData.append("max_win_per_person", promo_data.max_win_per_person);
        formData.append("addition_games_id", promo_data.addition_games_id_list);
        formData.append("wallet_key", promo_data.wallet_key || "");

        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/insert-global-promo",formData, { headers });
        const data = response.data;
        return data;
    },
    async UpdateGlobalPromoConfig(brandCode,promo_data) {
        const formData = new FormData();
        formData.append('id', promo_data.id);
        formData.append('brand_code', promo_data.brand_code);
        formData.append('promotion_name', promo_data.promotion_name);
        formData.append('promotion_type', promo_data.promotion_type);
        formData.append('trigger_id', promo_data.trigger_id);
        formData.append('is_giid_only', promo_data.is_giid_only ? 1 : 0);
        formData.append('max_chance_per_day', promo_data.max_chance_per_day);
        formData.append('addition_rules_id', promo_data.addition_rules_id_list);
        formData.append('removal_rules_id', promo_data.removal_rules_id_list);
        formData.append('start_date_promo', promo_data.start_date_promo);
        formData.append('end_date_promo', promo_data.end_date_promo);
        formData.append("promo_group", promo_data.promo_group);
        formData.append("max_win_per_person", promo_data.max_win_per_person);
        formData.append("addition_games_id", promo_data.addition_games_id_list);
        formData.append("removal_games_id", promo_data.removal_games_id_list);
        formData.append("wallet_key", promo_data.wallet_key || "");

        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/update-global-promo",formData, { headers });
        const data = response.data;
        return data;
    },
    async GetAllPromoConfig(brandCode) {
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.get(config.GiveAwayAPI_URL + "/api/get-all-promo", { headers });
        const data = response.data;
        return data;
    },
    async DeleteGlobalPromoConfig(brandCode, promo_data) {
        const formData = new FormData();
        formData.append('id', promo_data.id);
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/delete-global-promo", formData, { headers });
        const data = response.data;
        return data;
    },
    async CheckValidPromoDate(brandCode,promotion_type,promo_id,start_date,end_date,promo_group) {
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.get(config.GiveAwayAPI_URL + "/api/check-valid-promo-date?brand_code="+brandCode+"&&promo_type="+promotion_type+"&&promo_id="+promo_id+"&&start_date=" + start_date +"&&end_date=" + end_date +"&&promo_group="+promo_group, { headers });
        const data = response.data;
        return data;
    },
    async GetPromoBySearch(brandCode, promoType) {
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.get(config.GiveAwayAPI_URL + "/api/getPromoByPromoType?promoType=" + encodeURIComponent(promoType), { headers });
        const data = response.data;
        return data;
    },
    async GetAllTrigger(brandCode) {
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.get(config.GiveAwayAPI_URL + "/api/get-all-trigger", { headers });
        const data = response.data;
        return data;
    },
    async AddGlobalPromoTrigger(brandCode,trigger_data) {
        const formData = new FormData();
        formData.append('brand_code', trigger_data.brand_code);
        formData.append('trigger_name', trigger_data.trigger_name);
        formData.append('trigger_type', trigger_data.trigger_type);
        formData.append('promotion_type', trigger_data.promotion_type);
        formData.append('sku', trigger_data.sku);
        formData.append('trigger_value', trigger_data.trigger_value);

        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/insert-global-promo-trigger",formData, { headers });
        const data = response.data;
        return data;
    },
    async UpdateGlobalPromoTrigger(brandCode,trigger_data) {
        const formData = new FormData();
        formData.append('id', trigger_data.id);
        formData.append('brand_code', trigger_data.brand_code);
        formData.append('trigger_name', trigger_data.trigger_name);
        formData.append('trigger_type', trigger_data.trigger_type);
        formData.append('promotion_type', trigger_data.promotion_type);
        formData.append('sku', trigger_data.sku);
        formData.append('trigger_value', trigger_data.trigger_value);

        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/update-global-promo-trigger",formData, { headers });
        const data = response.data;
        return data;
    },
    async DeleteGlobalPromoTrigger(trigger_data, brandCode) {
        const formData = new FormData();
        formData.append('id', trigger_data.id);
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/delete-global-promo-trigger", formData, { headers });
        const data = response.data;
        return data;
    },
    async AddGlobalPromoRules(brandCode,rules_data) {
        const formData = new FormData();
        formData.append('brand_code', rules_data.brand_code);
        formData.append('promotion_type', rules_data.promotion_type);
        formData.append('rules_name', rules_data.rules_name);
        formData.append('deducted_amount', rules_data.deducted_amount);
        formData.append('probability', rules_data.probability);
        formData.append('win_limit', rules_data.win_limit);
        formData.append('addition_major_prizes_id', rules_data.addition_major_prizes_id_list);
        formData.append('win_limit_per_person', rules_data.win_limit_per_person);
        formData.append('target_refferal_count', rules_data.target_refferal_count);
        formData.append('default_rule', rules_data.default_rule_flag);
        formData.append('is_slice_free_spin', rules_data.is_slice_free_spin_flag);
        formData.append('is_slice_try_again', rules_data.is_slice_try_again_flag);
        formData.append('campaign_identifier', rules_data.campaign_identifier);
        formData.append('last_login_date', rules_data.last_login_date);
        formData.append('description', rules_data.description);
        formData.append('image_url', rules_data.image_url);   
        formData.append('target_donation_amount', rules_data.target_donation_amount);        
        formData.append('sub_promotion_type', rules_data.sub_promotion_type);
        formData.append('input_count', rules_data.input_count);
        formData.append('flash_promo_id', rules_data.flash_promo_id);
        formData.append('special_prize_condition_ids', rules_data.special_prize_condition_ids);
        formData.append('grace_period', rules_data.grace_period);
        formData.append("icon_url", rules_data.icon_url);
        formData.append("group_outer", rules_data.group_outer);
        formData.append("group_inner", rules_data.group_inner);
        formData.append("rank", rules_data.rank);
        formData.append("outer_group_color", rules_data.outer_group_color);
        formData.append("inner_group_color", rules_data.inner_group_color);
        
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/insert-global-promo-rules",formData, { headers });
        const data = response.data;
        return data;
    },
    async DeleteGlobalPromoRules(brandCode, rules_data) {
        const formData = new FormData();
        formData.append('id', rules_data.id);
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/delete-global-promo-rules", formData, { headers });
        const data = response.data;
        return data;
    },
    async UpdateGlobalPromoRules(brandCode,rules_data) {
        const formData = new FormData();
        formData.append('id', rules_data.id);
        formData.append('brand_code', rules_data.brand_code);
        formData.append('promotion_type', rules_data.promotion_type);
        formData.append('rules_name', rules_data.rules_name);
        formData.append('deducted_amount', rules_data.deducted_amount);
        formData.append('probability', rules_data.probability);
        formData.append('win_limit', rules_data.win_limit);
        formData.append('win_limit_per_person', rules_data.win_limit_per_person);
        formData.append('default_rule', rules_data.default_rule_flag);
        formData.append('is_slice_free_spin', rules_data.is_slice_free_spin_flag);
        formData.append('is_slice_try_again', rules_data.is_slice_try_again_flag);
        formData.append('addition_major_prizes_id', rules_data.addition_major_prizes_id_list);
        formData.append('removal_major_prizes_id', rules_data.removal_major_prizes_id_list);
        formData.append('campaign_identifier', rules_data.campaign_identifier);
        formData.append('target_refferal_count', rules_data.target_refferal_count);
        formData.append('last_login_date', rules_data.last_login_date);
        formData.append('description', rules_data.description);
        formData.append('image_url', rules_data.image_url);   
        formData.append('target_donation_amount', rules_data.target_donation_amount);
        formData.append('sub_promotion_type', rules_data.sub_promotion_type);
        formData.append('input_count', rules_data.input_count);
        formData.append('flash_promo_id', rules_data.flash_promo_id);
        formData.append('special_prize_condition_ids', rules_data.special_prize_condition_ids);
        formData.append("grace_period", rules_data.grace_period);
        formData.append("group_outer", rules_data.group_outer);
        formData.append("group_inner", rules_data.group_inner);
        formData.append("icon_url", rules_data.icon_url);
        formData.append("rank", rules_data.rank);
        formData.append("outer_group_color", rules_data.outer_group_color);
        formData.append("inner_group_color", rules_data.inner_group_color);

        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/update-global-promo-rules",formData, { headers });
        const data = response.data;
        return data;
    },
    async GetAllRules(brandCode) {
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.get(config.GiveAwayAPI_URL + "/api/get-all-rules", { headers });
        const data = response.data;
        return data;
    },

    async GetAllPrizesByBrandCode(brandCode) {
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.get(config.GiveAwayAPI_URL + "/api/get-all-prize-by-brand", { headers });
        const data = response.data;
        return data;
    },
    //end global promo config
    //start resend order
    async resendorder(brandCode,id,order_id) {
        const formData = new FormData();
        formData.append('id', id);
        formData.append('order_id', order_id);
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/resend-order",formData, { headers });
        const data = response.data;
        return data;
    },
    //end resend order
    //start ugc 
    async getUGCContestById(brandCode, contest_id) {
        const formData = new FormData();
        formData.append('contest_id', contest_id);
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.get(config.GiveAwayAPI_URL + "/api/getUGCContestById", formData,{ headers });
        const data = response.data;
        return data;
    },
    async approvePublishContestImage(brandCode,transaction_id) {
        const formData = new FormData();
        formData.append('transaction_id', transaction_id);
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/approvePublishContestImage",formData, { headers });
        const data = response.data;
        return data;
    },
    async ApproveWinner(brandCode,transaction_id) {
        const formData = new FormData();
        formData.append('transaction_id', transaction_id);
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/approveVoteWinner",formData, { headers });
        const data = response.data;
        return data;
    },
    //end ugc approve
    //start upc unblock user
    async UPCUnBlockUser(brandCode,id) {
        const formData = new FormData();
        formData.append('id', id);
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/UnblockUserUPC",formData, { headers });
        const data = response.data;
        return data;
    },
    //end upc unblock user
    async UnBlockUserAPI(brandCode,id) {
        const formData = new FormData();
        formData.append('id', id);
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/AnomalyDetection/unblock-user-api",formData, { headers });
        const data = response.data;
        return data;
    },

    async AddSchedulerReProcess(brandCode, payload) {
        const formData = new FormData();
        formData.append('brand_code', brandCode);
        formData.append('start_date', payload.start_date);
        formData.append('end_date', payload.end_date);
        formData.append('reprocess', payload.reprocess);
        formData.append('process_category', payload.process_category);
        formData.append('sub_process_category', payload.sub_process_category);
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
        };
        const response = await axios.post(
            config.GiveAwayAPI_URL + '/api/add-scheduler-reprocess',
            formData,
            { headers }
        );
        const data = response.data;
        return data;
    },

    async GetAllSpecialPrizeConditionConfig(brandCode){
        const idToken = (await Auth.currentSession()).getIdToken().getJwtToken()
        const response = await axios.get(
            config.GiveAwayAPI_URL + "/api/get-all-special-prize",
            {
                headers: {
                    'brand-code': brandCode,
                    Authorization: `Bearer ${idToken}`
                },
            }
        );
        const data = response.data;
        return data;
    }, 

    async CreateSpecialPrizeConditionConfig(brandCode, body) {
        const idToken = (await Auth.currentSession()).getIdToken().getJwtToken();
    
        const requestBody = {
            sku: body.sku,
            sku_name: body.sku_name,
            start_date: body.start_date,
            end_date: body.end_date,
            prize_ids: body.prize_ids,
            image_urls: body.image_urls,
        };
    
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${idToken}`,
            'Content-Type': 'application/json'
        };
    
        const response = await axios.post(
            config.GiveAwayAPI_URL + "/api/add-special-prize",
            requestBody,
            {
                headers: headers
            }
        );
    
        const data = response.data;
        return data;
    },

    async UpdateSpecialPrizeConditionConfig(brandCode, body) {
        const idToken = (await Auth.currentSession()).getIdToken().getJwtToken();
    
        const requestBody = {
            id: body.id,
            sku: body.sku,
            sku_name: body.sku_name,
            start_date: body.start_date,
            end_date: body.end_date,
            prize_ids: body.prize_ids,
            image_urls: body.image_urls,
        };
    
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${idToken}`,
            'Content-Type': 'application/json'
        };
    
        const response = await axios.put(
            config.GiveAwayAPI_URL + "/api/update-special-prize",
            requestBody,
            {
                headers: headers
            }
        );
    
        const data = response.data;
        return data;
    },

    async DeleteSpecialPrizeConditionConfig(brandCode, body) {
        const formData = new FormData();
        formData.append('id', body.id);
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };

        const response = await axios.delete(config.GiveAwayAPI_URL + "/api/delete-special-prize", { data: formData, headers: { 'Content-Type': 'multipart/form-data', ...headers } });
        const data = response.data;
        return data;
    },

    async GetAllPromoter(brandCode) {
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.get(config.GiveAwayAPI_URL + "/api/get-all-promoter", { headers });
        const data = response.data;
        return data;
    },
    async AddPromoter(brandCode, promoter_data) {
        const formData = new FormData();
        formData.append('brand_code', promoter_data.brand_code);
        formData.append('promoter_code', promoter_data.promoter_code);
        formData.append('promoter_desc', promoter_data.promoter_desc);
        formData.append('valid_start_date', promoter_data.valid_start_date);
        formData.append('valid_end_date', promoter_data.valid_end_date);

        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/insert-promoter",formData, { headers });
        const data = response.data;
        return data;
    },
    async UpdatePromoter(brandCode, promoter_data) {
        const formData = new FormData();
        formData.append('id', promoter_data.id);
        formData.append('brand_code', promoter_data.brand_code);
        formData.append('promoter_code', promoter_data.promoter_code);
        formData.append('promoter_desc', promoter_data.promoter_desc);
        formData.append('valid_start_date', promoter_data.valid_start_date);
        formData.append('valid_end_date', promoter_data.valid_end_date);

        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/update-promoter",formData, { headers });
        const data = response.data;
        return data;
    },
    async DeletePromoter(brandCode, promoter_data) {
        const formData = new FormData();
        formData.append('id', promoter_data.id);
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/delete-promoter", formData, { headers });
        const data = response.data;
        return data;
    },
    async ImportPromoter(brandCode, file) {
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const formData = new FormData();
        formData.append('file_base64', file);
        formData.append('brandCode', brandCode);
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/import-promoter", formData, { headers });
        const data = response.data;
        return data;
    },

    async fetchLoginUser() {
        return Auth.currentAuthenticatedUser()
    },
    async updatePassword(user, oldPassword, newPassword) {
        return Auth.changePassword(
            user,
            oldPassword,
            newPassword
        );
    },

    async completeNewPassword(user, password) {
        return Auth.completeNewPassword(
            user,
            password
        )
    },

    async cognitoOauth2(code) {
        try {
            let strUrl = config.CognitoCustomDomain;
            const details = {
                grant_type: "authorization_code",
                code: code,
                client_id: awsconfig.aws_user_pools_web_client_id,
                redirect_uri: config.SSO_CallbackUrl
            };
            const formBody = Object.keys(details).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(details[key])}`).join("&");
            let headers = {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
            let response = await axios.post(strUrl + "/oauth2/token", formBody, headers);
            headers.Authorization = 'Bearer ' + response.data.access_token;
            let userInfo = await axios.get(strUrl + "/oauth2/userInfo", { headers: headers });

            return {
                token_info: response.data,
                user_info: userInfo.data
            };
        } catch (error) {
            console.log(error);
            return {
                token_info: null,
                user_info: null
            };
        }
    },
    AllConfig() {
        return {
            cognito: awsconfig,
            api_url: config
        }
    },

    async GetAllPrizeConfig(brandCode) {
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.get(config.GiveAwayAPI_URL + "/api/get-all-prize-config", { headers });
        const data = response.data;
        return data;
    },

    async AddPrizeConfig(prizeConfigBody) {
        prizeConfigBody.merchantID_voucher = String(prizeConfigBody.merchantID_voucher);
        const headers = {
            'brand-code': prizeConfigBody.brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/add-prize-config",prizeConfigBody, { headers });
        const data = response.data;
        return data;
    },
    async UpdatePrizeConfig(prizeConfigBody) {
        prizeConfigBody.merchantID_voucher = String(prizeConfigBody.merchantID_voucher);
        const headers = {
            'brand-code': prizeConfigBody.brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.put(config.GiveAwayAPI_URL + "/api/update-prize-config",prizeConfigBody, { headers });
        const data = response.data;
        return data;
    },
    async DeletePrizeConfig(prizeConfigBody) {
        const headers = {
            'brand-code': prizeConfigBody.brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/delete-prize-config", prizeConfigBody, { headers });
        const data = response.data;
        return data;
    },

    async GetAllGlobalConfig(brandCode) {
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.get(config.GiveAwayAPI_URL + "/api/get-all-global-configuration", { headers });
        const data = response.data;
        return data;
    },

    async AddGlobalConfig(body) {
        const headers = {
            'brand-code': body.brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/add-global-configuration",body, { headers });
        const data = response.data;
        return data;
    },
    async UpdateGlobalConfig(body) {
        const headers = {
            'brand-code': body.brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.put(config.GiveAwayAPI_URL + "/api/update-global-configuration",body, { headers });
        const data = response.data;
        return data;
    },
    async GetRoleMapping(roles) {
        const headers = {
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.get(config.GiveAwayAPI_URL + "/api/get-role-mapping?roles=" + roles , { headers });
        const data = response.data;
        return data;
    },

    async GetAllGames(brandCode, search) {
        const headers = {
        "brand-code": brandCode,
        Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        };
        const response = await axios.get(config.GiveAwayAPI_URL + "/api/get-all-game-config?search=" + search , { headers });
        const data = response.data;
        return data;
    },

    // User Task Config
    async GetAllUserTaskConfig(brandCode) {
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.get(config.GiveAwayAPI_URL + "/api/get-user-task-config", { headers });
        const data = response.data;
        return data;
    },

    async CreateUserTaskConfig(userTaskBody) {

        const headers = {
            'brand-code': userTaskBody.brand_code,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/insert-user-task-config",userTaskBody, { headers });
        const data = response.data;
        return data;
    },

    async UpdateUserTaskConfig(userTaskBody) {

        const headers = {
            'brand-code': userTaskBody.brand_code,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.put(config.GiveAwayAPI_URL + "/api/update-user-task-config",userTaskBody, { headers });
        const data = response.data;
        return data;
    },

    async DeleteUserTaskConfig(userTaskBody) {
        const headers = {
            'brand-code': userTaskBody.brand_code,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/delete-user-task-config",userTaskBody, { headers });
        const data = response.data;
        return data;
    },

    // User Task Rules
    async GetAllUserTaskRulesConfig(brandCode) {
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.get(config.GiveAwayAPI_URL + "/api/get-user-task-rules", { headers });
        const data = response.data;
        return data;
    },

    async UpdateUserTaskRulesConfig(userTaskRulesBody) {
        const headers = {
            'brand-code': userTaskRulesBody.brand_code,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.put(config.GiveAwayAPI_URL + "/api/update-user-task-rules",userTaskRulesBody, { headers });
        const data = response.data;
        return data;
    },

    async CreateUserTaskRulesConfig(userTaskRulesBody) {
        const headers = {
            'brand-code': userTaskRulesBody.brand_code,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/insert-user-task-rules",userTaskRulesBody, { headers });
        const data = response.data;
        return data;
    },

    async DeleteUserTaskRulesConfig(userTaskRulesBody) {
        const headers = {
            'brand-code': userTaskRulesBody.brand_code,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/delete-user-task-rules",userTaskRulesBody, { headers });
        const data = response.data;
        return data;
    },
    //get all reaction
    async GetAllUserTaskReaction(brandCode) {
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.get(config.GiveAwayAPI_URL + "/api/get-user-task-reaction", { headers });
        const data = response.data;
        return data;
    },

    //insert reaction
    async AddUserTaskReaction(brandCode,reaction_data) {
        const formData = new FormData();
        formData.append('id', reaction_data.id);
        formData.append('brand_code', reaction_data.brand_code);
        formData.append('reaction', reaction_data.reaction);
        formData.append('image_url', reaction_data.image_url);

        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/insert-user-task-reaction",formData, { headers });
        const data = response.data;
        return data;
    },
    //update reaction
    async UpdateUserTaskReaction(brandCode,reaction_data) {
        const formData = new FormData();
        formData.append('id', reaction_data.id);
        formData.append('brand_code', reaction_data.brand_code);
        formData.append('reaction', reaction_data.reaction);
        formData.append('image_url', reaction_data.image_url);

        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.put(config.GiveAwayAPI_URL + "/api/update-user-task-reaction",formData, { headers });
        const data = response.data;
        return data;
    },

    //delete reaction
    async DeleteUserTaskReaction(brandCode, reaction_data) {
        const formData = new FormData();
        formData.append('id', reaction_data.id);
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.delete(config.GiveAwayAPI_URL + "/api/delete-user-task-reaction", { data: formData, headers: { 'Content-Type': 'multipart/form-data', ...headers } });
        const data = response.data;
        return data;
    },

    //get response
    async GetAllUserTaskResponse(brandCode) {
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.get(config.GiveAwayAPI_URL + "/api/get-user-task-response", { headers });
        const data = response.data;
        return data;
    },

    //insert response
    async AddUserTaskResponse(response_data) {
        const headers = {
            'brand-code': response_data.brand_code,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.post(config.GiveAwayAPI_URL + "/api/insert-user-task-response",response_data, { headers });
        const data = response.data;
        return data;
    },

    //update response
    async UpdateUserTaskResponse(response_data) {
        console.log("api response data", response_data);
        const headers = {
            'brand-code': response_data.brand_code,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.put(config.GiveAwayAPI_URL + "/api/update-user-task-response",response_data, { headers });
        const data = response.data;
        return data;
    },

    //delete response
    async DeleteUserTaskResponse(brandCode, response_data) {
        const formData = new FormData();
        formData.append('id', response_data.id);
        const headers = {
            'brand-code': brandCode,
            Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`
        };
        const response = await axios.delete(config.GiveAwayAPI_URL + "/api/delete-user-task-response", { data: formData, headers: { 'Content-Type': 'multipart/form-data', ...headers } });
        const data = response.data;
        return data;
    },
}